import { LinearProgress, LinearProgressProps } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import React from 'react';
import { theme } from '../../theme/theme';

const useProgressBarClasses = makeStyles({
    root: {
        '&.MuiLinearProgress-root': {
            borderRadius: 2,
            background: `${theme.colors.green[4]}55`,
        },
        '& .MuiLinearProgress-bar': {
            borderRadius: 2,
            background: theme.colors.green[4],
        },
    },
});

/**
 * Themed material-ui linear progress, this element only has one style, so properties like `props.color` are ignored.
 *
 * @param props.color enforced type
 */
export const ProgressBar = (props: LinearProgressProps & { color?: never }) => {
    const classes = useProgressBarClasses();

    return <LinearProgress {...props} className={clsx(classes.root, props.classes?.root)} />;
};
